import React, {Component} from 'react';
import {Card, Dimmer, Loader} from 'semantic-ui-react';
import TicketData from "../../data/TicketData";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {dynamicTableAddOrUpdate} from "../../actions/DynamicTableDataAction";

class CheckTicket extends Component {
    constructor(props){
        super(props);
        this.state = {
            checked:props.checked,
            sending: false
        }
    }

    handleClick = () => {
       let data = {
           ticket_client: this.props.id,
           ticket_product: this.props.ticket,
       };
       if(!this.state.checked){
           this.setState({sending:true});
           TicketData.checkDelete(data, (res) => {
               if(res.delete){
                   this.setState({checked: !this.state.checked});
                   this.props.dynamicTableAddOrUpdate(res.data);
                   this.props.showToast({message:'Tiquetera borrada', type:'success'})
               }else{
                   this.props.showToast({message:'Tenemos un problema', type:'error'})
               }
           }).catch(()=>{
               this.props.showToast({message:'Tenemos un problema', type:'error'})
           }).finally(()=>{
               this.setState({sending:false});
           });
       }else{
           this.setState({sending:true});
           TicketData.check(data, (res) => {
               if(res.check){
                   this.props.dynamicTableAddOrUpdate(res.data);
                   this.setState({checked: !this.state.checked});
                   this.props.showToast({message:'Tiquetera marcada', type:'success'})
               }else{
                   this.props.showToast({message:res.message, type:'error'})
               }
           }).catch(()=>{
               this.props.showToast({message:'Tenemos un problema', type:'error'})
           }).finally(()=>{
               this.setState({sending:false});
           });
       }
    };

    render() {
        return (
            <Card
                raised
                style={{margin:'0.5em', backgroundColor:this.state.checked ? null:'#e44745', color:this.state.checked ? null:'#fff'}}
                onClick={this.handleClick}
            >
                <Card.Content textAlign='center'>
                    <strong>{this.props.number }</strong>
                </Card.Content>
                {this.state.sending ?<Dimmer active inverted>
                    <Loader size='mini' />
                </Dimmer>:null}
            </Card>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data){
            dispatch(showToast(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
    }
}

export default connect(
    null,
    mapDispatchToProps
)(CheckTicket);


// WEBPACK FOOTER //
// ./src/components/services/CheckTicket.js